/**
 * Create Lead Page
 * ================
 * Dedicated page for creating a new lead
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';
import { DashboardLayout } from '../../components/layout';
import { LeadCreateForm } from '../../components/leads';
import { useToast } from '../../hooks';
import mockAPI from '../../api/mock';

const CreateLeadPage = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [mockLoading, setMockLoading] = useState(false);

  const handleSuccess = (data) => {
    showToast('Lead created.', 'success');
    navigate('/leads');
  };

  const handleCancel = () => {
    navigate('/leads');
  };

  const handleCreateMockLead = async () => {
    setMockLoading(true);
    try {
      const response = await mockAPI.createMockLead();
      const data = response.data;
      showToast(
        `Mock lead created: ${data.lead_name} (${data.company}). Questionnaire generating in background.`,
        'success'
      );
      navigate(`/leads/${data.lead_id}`);
    } catch (err) {
      console.error('Error creating mock lead:', err);
      const errorMessage = err.response?.data?.detail || 'Failed to create mock lead';
      showToast(errorMessage, 'error');
    } finally {
      setMockLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-[28px] font-sans font-bold text-gray-900 dark:text-white mb-2">
              Create New Lead
            </h1>
            <p className="text-gray-500 dark:text-gray-400">
              Add a new lead
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={handleCreateMockLead}
              disabled={mockLoading}
              className="bg-amber-500 hover:bg-amber-600 text-white border-amber-500"
            >
              {mockLoading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                  Creating Mock Lead...
                </span>
              ) : (
                'Create Mock Lead'
              )}
            </Button>
            <Button variant="outline" onClick={handleCancel}>
              ← Back to List
            </Button>
          </div>
        </div>

        {/* Create Form */}
        <LeadCreateForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </div>
    </DashboardLayout>
  );
};

export default CreateLeadPage;

